/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsListQueryResponse, ProjectsListQueryParams } from "../models/ProjectsList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectsList } from "../axios/projectsList";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const projectsListQueryKey = (params?: ProjectsListQueryParams) => ["video-editor-api", { url: '/projects' }, ...(params ? [params] : [])] as const

export type ProjectsListQueryKey = ReturnType<typeof projectsListQueryKey>

export function projectsListQueryOptions(params?: ProjectsListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = projectsListQueryKey(params)
  return queryOptions<ProjectsListQueryResponse, ResponseErrorConfig<Error>, ProjectsListQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return projectsList(params, config)
   },
  })
}

/**
 * @summary List projects for the client (optionally by source type and id)
 * {@link /projects}
 */
export function useProjectsList<TData = ProjectsListQueryResponse, TQueryData = ProjectsListQueryResponse, TQueryKey extends QueryKey = ProjectsListQueryKey>(params?: ProjectsListQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ProjectsListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? projectsListQueryKey(params)

  const query = useQuery({
   ...projectsListQueryOptions(params, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}